import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { Box, Typography } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import { getTestIds } from 'seagull/utils/TestIds';
import { formatPercent } from '../InvoiceMetricsSection.utils';
import { MetricsCard } from '../MetricsCard/MetricsCard';
import styles from './DonutRingCard.module.scss';
const DONUT_SIZE = 48;
const DONUT_INNER_RADIUS = 20;
const DONUT_OUTER_RADIUS = 23;
export const GetDonutRingCardTID = (parentTestId)=>getTestIds(parentTestId);
const clampRatio = (ratio)=>Math.max(0, Math.min(1, ratio));
export const DonutRingCard = (param)=>{
    let { title, tooltip, ratio, isEmpty, subtitle, emptyPrimary, emptySubtitle, isActive = false, isEditMode = false, isLoading = false, isRefetching = false, onRemove, dragHandle, onClick, testId } = param;
    const { DonutRingCardTestIds } = useMemo(()=>GetDonutRingCardTID(testId), [
        testId
    ]);
    const safeRatio = isEmpty ? 0 : clampRatio(ratio);
    const primaryText = isEmpty ? emptyPrimary : formatPercent(safeRatio);
    const subtitleText = isEmpty ? emptySubtitle : subtitle;
    const ringData = useMemo(()=>[
            {
                name: 'filled',
                value: safeRatio
            },
            {
                name: 'remaining',
                value: 1 - safeRatio
            }
        ], [
        safeRatio
    ]);
    return /*#__PURE__*/ _jsx(MetricsCard, {
        title: title,
        tooltip: tooltip,
        isActive: isActive,
        isDisabled: isEmpty,
        isEditMode: isEditMode,
        isLoading: isLoading,
        isRefetching: isRefetching,
        onRemove: onRemove,
        dragHandle: dragHandle,
        onClick: onClick,
        testId: DonutRingCardTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Box, {
            className: styles.body,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    "data-testid": DonutRingCardTestIds.Ring(),
                    "data-arc-ratio": safeRatio,
                    className: styles.ring,
                    style: {
                        width: DONUT_SIZE,
                        height: DONUT_SIZE
                    },
                    children: /*#__PURE__*/ _jsx(ResponsiveContainer, {
                        width: "100%",
                        height: "100%",
                        children: /*#__PURE__*/ _jsx(PieChart, {
                            children: /*#__PURE__*/ _jsxs(Pie, {
                                data: ringData,
                                dataKey: "value",
                                nameKey: "name",
                                innerRadius: DONUT_INNER_RADIUS,
                                outerRadius: DONUT_OUTER_RADIUS,
                                startAngle: 90,
                                endAngle: -270,
                                stroke: "none",
                                isAnimationActive: false,
                                children: [
                                    /*#__PURE__*/ _jsx(Cell, {
                                        "data-testid": DonutRingCardTestIds.RingArc(),
                                        fill: colors.purple700
                                    }),
                                    /*#__PURE__*/ _jsx(Cell, {
                                        fill: colors.dark100
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    className: styles.text,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h5",
                            weight: "normal",
                            testId: DonutRingCardTestIds.PrimaryValue(),
                            className: styles.primaryValue,
                            children: primaryText
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph3",
                            skin: "secondary",
                            testId: DonutRingCardTestIds.Subtitle(),
                            className: styles.subtitle,
                            children: subtitleText
                        })
                    ]
                })
            ]
        })
    });
};
